export default function LoadingState({ message }) {
  return (
    <div data-testid="loading-state" className="text-center py-12">
      <div
        className="w-10 h-10 rounded-full animate-spin-slow mx-auto mb-4"
        style={{
          border: "2px solid var(--sdb-border)",
          borderTopColor: "var(--sdb-accent)",
        }}
      />
      <div className="font-mono text-xs" style={{ color: "var(--sdb-text-secondary)" }}>
        {message || "Generating..."}
      </div>
      <div className="font-mono text-[10px] mt-1.5" style={{ color: "var(--sdb-text-subtle)" }}>
        Building relational integrity across tables...
      </div>
    </div>
  );
}
